export default "__VITE_ASSET__Dj_Hsc33__"